__webpack_public_path__ =
  process.env.NODE_ENV === 'production' ? ASSETS_PATH : ''
